import moment from 'moment';

export function installMomentHelper(app) {
	app.config.globalProperties.moment = function(time) {
		return moment(time);
	};
}

export function installAuthHelpers(app, store) {
	Object.defineProperties(app.config.globalProperties, {
		user: {
			get() {
				return store.getters['auth/user'];
			},
		},
		isCleaner: {
			get() {
				return store.getters['auth/isCleaner'];
			},
		},
		isClient: {
			get() {
				return store.getters['auth/isClient'];
			},
		},
	});
}

export function installPermissionHelpers(app, store) {
	const can = (permission) => {
		const user = store.state.auth.user;

		if (!user) {
			return false;
		}

		if (Array.isArray(permission)) {
			return permission.some(p => can(p));
		}

		return user.legacyPermissions[permission] || user.permissions[permission];
	};

	const hasRole = (role) => {
		const user = store.state.auth.user;

		if (!user) {
			return false;
		}

		if (Array.isArray(role)) {
			return role.some(r => hasRole(r));
		}

		return user.roles.some(r => r.name === role);
	};

	app.config.globalProperties.$can = can;
	app.config.globalProperties.$hasRole = hasRole;
	app.config.globalProperties.$isAdmin = () => can('is_admin') || hasRole('Admin');

	Object.defineProperty(app.config.globalProperties, 'isAdmin', {
		get() {
			return can('is_admin') || hasRole('Admin');
		},
	});
}
